import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatDate, getCurrentLanguageKey } from "../../utils/util";
import "../../styles/UserDashboard.scss";

const UserCertificationCard = ({
	certification : userCertifications, 
	certificationTemplate,
	handleCertificationDownload
}) => {
	const { t, i18n: { changeLanguage } } = useTranslation();

	useEffect(() => {
		changeLanguage(getCurrentLanguageKey());
	}, [changeLanguage]);

	const getCertificationStatus = (date) => {
		const expirationDate = new Date(date);
		expirationDate.setFullYear(expirationDate.getFullYear() + 2);
		return { expirationDate, isExpired: expirationDate < new Date() };
	};

	const { expirationDate, isExpired } = getCertificationStatus(userCertifications.date);

	return (
		<div
			key={userCertifications.id || userCertifications.testName} 
			className="card-container d-flex learn-education__landing-card p-4"
		>
			<div className="card-content-container d-flex flex-column justify-content-between">
				<h4>{userCertifications.testName}</h4>

				<div className="d-flex flex-column container-status-certification">
					<div className="certification-date-container d-flex flex-column">
						<span className="date-certification d-flex">
							{t('completed-on')}:
							<span>{formatDate(userCertifications.date)}</span>
						</span>

						<span className="expiration-date-certification d-flex">
							{t('expiration-on')}:
							<span>{formatDate(expirationDate)}</span>
						</span>
					</div>

					<div className="align-self-start d-flex tag-status-certification">
						<span
							className={`align-items-center d-flex tag-status 
							${isExpired ? "tag-status-expired" : "card-tag__completed"}`}
						>
							{isExpired ? t('expired') : t('up-to-date')}
						</span>
					</div>

					{certificationTemplate && (
						<div className="align-items-center certification-download-container d-flex">
							<button onClick={() => handleCertificationDownload(userCertifications)}>
								{t('download-certificate')}
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default UserCertificationCard;